import ParcelCardBody from './ParcelCardBody/ParcelCardBody'
import ParcelCardHeader from './ParcelCardHeader/ParcelCardHeader'
import * as Styles from './styles'

const ParcelCard = ({
  id,
  orderName,
  withCustoms,
  senderAddress,
  senderName,
  recipientAddress,
  destinationAddress,
  trackingNumber,
  trackingUrl,
  status,
  createdAt,
  modifiedAt,
  itemsQuantity,
  notes,
  customer,
  carrierName,
  carrierLogo,
  shippingMethod,
  error,
  email,
  selected,
  onSelect,
  getParcelDetailHref,
  onParcelDetailClick,
  parcelDetailSelectedId,
  sequenceInfo,
  pickupDate,
  type,
  isExchange,
}) => {
  const handleClick = event => onParcelDetailClick(event, id)

  return (
    <Styles.ParcelCardContainer
      href={getParcelDetailHref(id)}
      onClick={handleClick}
      selected={selected}
      isParcelDetailSelected={parcelDetailSelectedId === id}
    >
      <ParcelCardHeader
        orderName={orderName}
        withCustoms={withCustoms}
        senderAddress={senderAddress}
        recipientAddress={destinationAddress}
        trackingNumber={trackingNumber}
        trackingUrl={trackingUrl}
        status={status}
        selected={selected}
        onSelect={onSelect}
        sequenceInfo={sequenceInfo}
        type={type}
        isExchange={isExchange}
      />
      <ParcelCardBody
        error={error}
        recipientAddress={recipientAddress}
        destinationAddress={destinationAddress}
        senderAddress={senderAddress}
        senderName={senderName}
        createdAt={createdAt}
        modifiedAt={modifiedAt}
        itemsQuantity={itemsQuantity}
        notes={notes}
        customer={customer}
        carrierName={carrierName}
        carrierLogo={carrierLogo}
        shippingMethod={shippingMethod}
        email={email}
        pickupDate={pickupDate}
      />
    </Styles.ParcelCardContainer>
  )
}

export default ParcelCard
